import React from 'react';
import styled from '@emotion/styled';
import { SerializedStyles } from '@emotion/react';

export interface ButtonProps {
  width?: number;
  height?: number;
  fontSize?: number;
  diameter?: number;
  styles?: SerializedStyles;
}

export const SearchIconButtonStyled = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  padding: calc(${(props: ButtonProps) => props.diameter || 16}px / 4);
  height: ${(props: ButtonProps) => props.diameter || 16}px;
  width: ${(props: ButtonProps) => props.diameter || 16}px;
  border-radius: calc(${(props: ButtonProps) => props.diameter || 16}px / 2);
  border-width: calc(${(props: ButtonProps) => props.diameter || 16}px / 16);
  position: relative;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0);
  ::before,
  ::after {
    box-sizing: border-box;
    position: absolute;
    content: '';
  }
  ::before {
    width: 31.25%;
    height: 31.25%;
    left: 28.125%;
    top: 28.125%;
    border-radius: 100%;
    border-width: calc(${(props: ButtonProps) => props.diameter || 16}px / 16);
    border-style: solid;
    border-color: #555555;
  }
  ::after {
    width: 16.6875%;
    height: 14.3125%;
    left: 55.1875%;
    top: 56.875%;
    border-width: calc(${(props: ButtonProps) => props.diameter || 16}px / 16) 0px 0px 0px;
    border-style: solid;
    border-color: #555555;
    border-top-right-radius: calc(${(props: ButtonProps) => props.diameter || 16}px / 16);
    transform: rotate(45deg);
  }
  :hover {
    border-color: #7fe200;
    background-color: #effdda;
    :before,
    :after {
      border-color: #7fe200;
    }
  }
  :active {
    border-color: #7fe200;
    background-color: #7fe200;
    :before,
    :after {
      border-color: #ffffff;
    }
  }
  ${(props: ButtonProps) => props.styles};
`;

const SearchButton = ({ diameter = 40 }: any) => {
  return <SearchIconButtonStyled diameter={diameter} />;
};

export default SearchButton;
